<template>
  <el-main>
    <div class="container">
      <div class="paper-info">
        <div class="paper-title">
          我的错题
        </div>
        <div class="paper-intro">
          <div>
            ◇ 在答题过程中凡是答错的题目都将进入错题库
          </div>
          <div>
            ◇ 错题再次答对将会移出错题库
          </div>
          <div class="clear-error">
            <el-button type="danger" size="mini" @click="clearError">清空错题库</el-button>
          </div>
        </div>
      </div>
      <div class="paper-body">
        <el-row :gutter="20">
          <el-col :span="18">
            <div class="paper-body-left">
              <div class="topic-list" v-if="topics && topics.length > 0">
                <div class="topic-item" v-for="(item, index) in topics" :key="index" v-if="topicIndex === index">
                  <div class="topic-title">
                    <span>{{ index + 1 }}、</span>
                    <span>【{{ item.topic.types.title }}】</span>
                    <span class="topic-html" v-html="item.topic.title"></span>
                  </div>
                  <div class="topic-images" v-if="item.topic.images && item.topic.images.length > 0">
                    <img :src="path + img_i" alt="" v-for="(img_i, img_n) in item.topic.images" :key="img_n"
                         class="topic-images-item">
                  </div>
                  <div class="topic-options">
                    <div class="topic-radio-box" v-if="item.topic.types.type === 1">
                      <el-radio-group v-model="item.userAnswer" @change="changeRadio(item, index)">
                        <el-radio :label="r_n" v-for="(r_i, r_n) in item.topic.options" v-if="r_i"
                                  class="topic-radio">
                          {{ r_n }}、<span class="topic-html" v-html="r_i"></span>
                        </el-radio>
                      </el-radio-group>
                    </div>
                    <div class="topic-checkbox-box" v-if="item.topic.types.type === 2 || item.topic.types.type === 4">
                      <el-checkbox-group v-model="item.userAnswer" @change="changeCheckbox(item, index)">
                        <el-checkbox :label="c_n" v-for="(c_i, c_n) in item.topic.options" v-if="c_i"
                                     class="topic-checkbox">{{ c_n }}、<span class="topic-html" v-html="c_i"></span>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div class="topic-radio-box" v-if="item.topic.types.type === 3">
                      <el-radio-group v-model="item.userAnswer" @change="changeRadio(item, index)">
                        <el-radio label="正确" class="topic-radio">正确</el-radio>
                        <el-radio label="错误" class="topic-radio">错误</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="topic-textarea-box" v-if="item.topic.types.type === 6">
                      <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入答案"
                        @input="changeTextarea(item, index)"
                        v-model="item.userAnswer">
                      </el-input>
                    </div>
                    <div class="topic-parts-box" v-if="item.topic.types.type === 5">
                      <div class="topic-list" v-if="item.part">
                        <div class="topic-item">
                          <div class="topic-title parts-title">
                            <span>【{{ item.part.types.title }}】</span>
                            <span class="topic-html" v-html="item.part.title"></span>
                          </div>
                          <div class="topic-images" v-if="item.part.images && item.part.images.length > 0">
                            <img :src="path + img_i" alt="" v-for="(img_i, img_n) in item.part.images" :key="img_n"
                                 class="topic-images-item">
                          </div>
                          <div class="topic-options">
                            <div class="topic-radio-box" v-if="item.part.types.type === 1">
                              <el-radio-group v-model="item.userAnswer" @change="changeRadio(item, index)">
                                <el-radio :label="r_n" v-for="(r_i, r_n) in item.part.options" v-if="r_i"
                                          class="topic-radio">
                                  {{ r_n }}、<span class="topic-html" v-html="r_i"></span>
                                </el-radio>
                              </el-radio-group>
                            </div>
                            <div class="topic-checkbox-box"
                                 v-if="item.part.types.type === 2 || item.part.types.type === 4">
                              <el-checkbox-group v-model="item.userAnswer" @change="changeCheckbox(item, index)">
                                <el-checkbox :label="c_n" v-for="(c_i, c_n) in item.part.options" v-if="c_i"
                                             class="topic-checkbox">{{ c_n }}、<span class="topic-html" v-html="c_i"></span>
                                </el-checkbox>
                              </el-checkbox-group>
                            </div>
                            <div class="topic-radio-box" v-if="item.part.types.type === 3">
                              <el-radio-group v-model="item.userAnswer" @change="changeRadio(item, index)">
                                <el-radio label="正确" class="topic-radio">正确</el-radio>
                                <el-radio label="错误" class="topic-radio">错误</el-radio>
                              </el-radio-group>
                            </div>
                            <div class="topic-textarea-box" v-if="item.part.types.type === 6">
                              <el-input
                                type="textarea"
                                :rows="5"
                                placeholder="请输入答案"
                                @input="changeTextarea(item, index)"
                                v-model="item.userAnswer">
                              </el-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="topic-analysis" v-if="analysis && item.topic.types.type !== 5">
                    <div>正确答案：
                      <span class="topic-analysis-answer"
                            v-if="item.topic.types.type !== 2 && item.topic.types.type !== 4">
                        {{ item.topic.answer }}</span>
                      <span class="topic-analysis-answer"
                            v-if="item.topic.types.type === 2 || item.topic.types.type === 4">
                        {{ getTypeAnswer(item.topic.answer) }}</span>
                    </div>
                    <div class="topic-analysis-body">
                      <div>解析：</div>
                      <div class="topic-analysis-body">
                        <el-button type="primary" plain size="small" @click="showAiAnalysis(item.topic.id)"
                                   v-if="!item.topic.analysisShow">
                          查看解析
                        </el-button>
                        <type-writer :ref="'topic_' + item.topic.id" :key="'topic_' + item.topic.id" :speed="50"
                                     v-if="item.topic.analysisShow && !item.topic.analysisEnd">
                        </type-writer>
                        <span v-if="item.topic.analysisEnd">
                          {{ item.topic.analysisBody }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="topic-analysis" v-if="analysis && item.topic.types.type === 5">
                    <div>正确答案：
                      <span class="topic-analysis-answer"
                            v-if="item.part.types.type !== 2 && item.part.types.type !== 4">
                        {{ item.part.answer }}</span>
                      <span class="topic-analysis-answer"
                            v-if="item.part.types.type === 2 || item.part.types.type === 4">
                        {{ getTypeAnswer(item.part.answer) }}</span>
                    </div>
                    <div class="topic-analysis-body">
                      <div>解析：</div>
                      <div v-html="item.part.analysis"></div>
                      <div class="topic-analysis-body">
                        <el-button type="primary" plain size="small"
                                   @click="showAiAnalysis(item.topic.id, item.part.id)"
                                   v-if="!item.part.analysisShow">
                          查看解析
                        </el-button>
                        <type-writer :ref="'topic_part_' + item.part.id" :key="'topic_part_' + item.part.id" :speed="50"
                                     v-if="item.part.analysisShow && !item.part.analysisEnd">
                        </type-writer>
                        <span v-if="item.part.analysisEnd">
                                  {{ item.part.analysisBody }}
                                </span>
                      </div>
                    </div>
                  </div>
                  <div class="topic-paper" v-if="item.paper">
                    来源试卷：{{ item.paper.title }}
                  </div>
                </div>
              </div>
              <div class="topic-nav">
                <el-button-group class="topic-nav-list">
                  <el-button class="topic-nav-item" icon="el-icon-arrow-left" @click="moveTopic(-1)">
                    上一题
                  </el-button>
                  <el-button class="topic-nav-item" icon="el-icon-document-checked"
                             @click="showAnalysis">
                    <span v-if="!analysis">查看答案</span>
                    <span v-if="analysis">关闭答案</span>
                  </el-button>
                  <el-button class="topic-nav-item" @click="moveTopic(1)">下一题<i
                    class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-button-group>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="paper-body-right">
              <div class="paper-card">
                答题卡
              </div>
              <div class="paper-card-body">
                <div class="paper-card-list">
                  <div class="paper-card-item" v-for="(item, index) in topics" :key="index">
                    <el-button class="topic-button" v-if="item.type !== 5"
                               :class="[item.userAnswer.length > 0 ? 'current' : '']" @click="goSwiper(index)">
                      {{ index + 1 }}
                    </el-button>
                    <el-button class="topic-button" v-if="item.type === 5" v-for="(i, n) in item.parts" :key="n"
                               :class="[i.userAnswer.length > 0 ? 'current' : '']" @click="goSwiper(index)">
                      {{ index + 1 }}-{{
                        n + 1
                      }}
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="paper-test">
                <el-button type="primary" class="test-button" @click="goTest">交卷</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-main>
</template>

<script>
import {authRequest} from "@/utils/request";
import date from "@/utils/date"
import TypeWriter from "@/components/type-writer/type-writer.vue"

export default {
  name: "studyTest",
  head() {
    return {
      title: '我的错题'
    }
  },
  components: {
    TypeWriter
  },
  data() {
    return {
      id: '',
      topicIndex: 0,
      path: process.env.VUE_APP_FILE,
      topics: [],
      analysis: false,
      now: '',
      analysisLoading: false
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getPaper()
    this.now = date.currentTime('str')
  },
  methods: {
    async showAiAnalysis(topic_id, part_id = null) {
      this.analysisLoading = true;

      const topic = this.topics[this.topicIndex].topic;

      // 初始化分析内容
      if (!topic.analysisBody) this.$set(topic, 'analysisBody', '');
      this.$set(topic, 'analysisShow', true);

      // 拼接消息
      let message = '';
      message += '题型为：' + topic.types.title + '\n';
      message += '题目为：' + topic.title + '\n';

      if ([1, 2, 4].includes(topic.type)) {
        const optionsStr = Object.entries(topic.options)
          .map(([k, v]) => `${k}: ${v}`)
          .join(', ');
        message += '选项有：' + optionsStr + '\n';
      }

      if (topic.answer) {
        const answerStr = Array.isArray(topic.answer) ? topic.answer.join(', ') : topic.answer.toString();
        if (answerStr.trim()) message += '答案为：' + answerStr + '\n';
      }

      let part;
      if (part_id) {
        part = this.topics[this.topicIndex].part

        if (!part.analysisBody) this.$set(part, 'analysisBody', '');
        this.$set(part, 'analysisShow', true);

        message += '材料子题目为：' + part.title + '\n';

        if ([1, 2, 4].includes(part.type)) {
          const optionsStr = Object.entries(part.options)
            .map(([k, v]) => `${k}: ${v}`)
            .join(', ');
          message += '选项有：' + optionsStr + '\n';
        }

        if (part.answer) {
          const answerStr = Array.isArray(part.answer) ? part.answer.join(', ') : part.answer.toString();
          if (answerStr.trim()) message += '答案为：' + answerStr + '\n';
        }
      }

      // 获取 TypeWriter 组件引用
      const refsId = part_id ? 'topic_part_' + part_id : 'topic_' + topic.id;
      await this.$nextTick();
      const typewriter = this.$refs[refsId][0];

      const socket = new WebSocket('wss://ai.qhzyjy.com/');

      // 连接打开
      socket.onopen = () => {
        socket.send(JSON.stringify({
          message,
          id: this.id,
          subclass_id: topic.subclass_id,
        }));
      };

      // 接收消息
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.result) {
          if (!part_id) {
            topic.analysisBody += data.result;
          } else {
            part.analysisBody += data.result;
          }

          // 实时追加 TypeWriter
          typewriter.appendText(data.result);
        }

        if (data.is_end) {
          this.analysisLoading = false;
          if (!part_id) {
            this.$set(topic, 'analysisEnd', true);
          } else {
            this.$set(part, 'analysisEnd', true);
          }
          socket.close();
        }

        if (data.error) {
          this.analysisLoading = false;
          socket.close();
        }
      };

      // 连接错误
      socket.onerror = (err) => {
        this.analysisLoading = false;
      };

      // 连接关闭
      socket.onclose = () => {
      };
    },
    async getPaper() {
      try {
        let response = await authRequest('test/error', {
          method: 'GET'
        })
        let topics = response.data
        topics.forEach((item, index) => {
          item.userAnswer = ''
          if (item.topic.types.type === 2 || item.topic.types.type === 4) {
            item.userAnswer = []
          }
          if (item.topic.types.type === 5 && item.part && (item.part.types.type === 2 || item.part.types.type === 4)) {
            item.userAnswer = []
          }
        })
        this.topics = topics
      } catch (e) {
        console.log(e)
      }
    },
    format(percentage) {
      return percentage === 100 ? '完成' : `${parseInt(percentage)}%`;
    },
    moveTopic(e) {
      if (e === -1) {
        if (this.topicIndex === 0) {
          this.$message.warning('已经是第一题啦～')
        } else {
          this.topicIndex -= 1;
        }
      }
      if (e === 1) {
        if (this.topicIndex < this.topics.length - 1) {
          this.topicIndex += 1;
        } else {
          this.$message.warning('已经是最后一题啦～')
        }
      }
    },
    changeRadio(item, index) {
      this.$set(this.topics, index, item)
      if (this.topicIndex < this.topics.length - 1) {
        this.topicIndex += 1;
      }
    },
    changeCheckbox(item, index) {
      this.$set(this.topics, index, item)
    },
    changeTextarea(item, index) {
      this.$set(this.topics, index, item)
    },
    showAnalysis() {
      this.analysis = !this.analysis
    },
    getTypeAnswer(value) {
      if (!value) {
        return ''
      }
      let result = []
      for (let i = 0; i < value.length; i++) {
        if (value[i]) {
          result.push(value[i])
        }
      }
      return result.toString()
    },
    goSwiper(index) {
      this.topicIndex = index
    },
    goTest() {
      this.$confirm('提交后，回答正确的将移出我的错题库', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.postTest()
      }).catch(() => {

      });
    },
    async postTest() {
      const loading = this.$loading({
        lock: true,
        text: '正在计算中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let test = this.topics
      let errorList = []
      test.forEach((item, index) => {
        if (item.userAnswer !== '' && item.topic.type !== 5) {
          if (item.topic.types.type === 1) {
            if (item.userAnswer === item.topic.answer) {
              errorList.push(item.id)
            }
          }
          if (item.topic.types.type === 2 || item.topic.types.type === 4) {
            let answer = []
            item.topic.answer.forEach((i, n) => {
              if (i) {
                answer.push(i)
              }
            })
            if (answer.toString() === item.userAnswer.toString()) {
              errorList.push(item.id)
            }
          }
          if (item.topic.types.type === 3) {
            if (item.userAnswer === item.topic.answer) {
              errorList.push(item.id)
            }
          }
        }
        if (item.userAnswer !== '' && item.topic.types.type === 5) {
          if (item.part.types.type === 1) {
            if (item.userAnswer === item.part.answer) {
              errorList.push(item.id)
            }
          }
          if (item.part.types.type === 2) {
            let answer = []
            item.part.answer.forEach((i, n) => {
              if (i) {
                answer.push(i)
              }
            })
            if (answer.toString() === item.userAnswer.toString()) {
              errorList.push(item.id)
            }
          }
          if (item.part.types.type === 3) {
            if (item.userAnswer === item.part.answer) {
              errorList.push(item.id)
            }
          }
          if (item.part.types.type === 4) {
            let answer = []
            item.part.answer.forEach((i, n) => {
              if (i) {
                answer.push(i)
              }
            })
            if (answer.toString() === item.userAnswer.toString()) {
              errorList.push(item.id)
            }
          }
        }
      })
      try {
        let response = await authRequest('test/error', {
          method: 'POST',
          data: {
            error: errorList
          }
        })
        if (response.status === 204) {
          loading.close()
          this.$message.success('提交成功')
          this.getPaper()
          this.topicIndex = 0
        }
      } catch (e) {
        loading.close()
      }
    },
    clearError() {
      this.$confirm('确认清空我的错题库？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        if (this.topics.length <= 0) {
          this.$message.info('当前还没有任何错题哦～')
        }
        try {
          let response = await authRequest('test/error/clear', {
            method: 'POST'
          })
          this.topics = response.data
          this.topicIndex = 0
        } catch (e) {

        }
      }).catch(() => {

      });
    }
  }
}
</script>

<style scoped>
.paper-info {
  background-color: #ffffff;
  padding: 0 20px;
  border-radius: 6px;
}

.paper-title {
  line-height: 60px;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  border-bottom: 1px dashed #ebebeb;
}

.paper-intro {
  padding: 10px 0;
  border-bottom: 1px dashed #ebebeb;
  position: relative;
}

.paper-progress {
  padding: 20px 0;
}

.paper-body {
  margin-top: 20px;
}

.paper-body-left, .paper-body-right {
  overflow: hidden;
  border-radius: 6px;
  background-color: #ffffff;
}

.topic-title {
  border-bottom: 1px dashed #ebebeb;
  padding: 20px;
  border-left: 3px solid #2aacb2;
}

.topic-images {
  padding: 20px;
  border-bottom: 1px dashed #ebebeb;
}

.topic-images-item {
  width: 100%;
  margin-right: 10px;
}

.topic-nav {
  margin-top: 30px;
}

.topic-nav-list {
  display: flex;
  justify-content: space-between;
}

.topic-nav-item {
  width: 33.33%;
}

.topic-options {
  padding: 20px;
}

.topic-radio, .topic-checkbox {
  width: 100%;
  margin-bottom: 15px;
}

.topic-radio:last-child, .topic-checkbox:last-child {
  margin-bottom: 0;
}

.topic-analysis {
  border-top: 1px dashed #ebebeb;
  padding: 20px;
}

.topic-analysis-body {
  margin-top: 10px;
}

.topic-analysis-answer {
  font-size: 18px;
  color: #2aacb2;
  font-weight: 500;
}

.parts-title {
  background-color: #f3f3f3;
  padding: 10px;
  border-left: 0;
}

.paper-card {
  padding: 20px;
  border-left: 3px solid #2aacb2;
  border-bottom: 1px dashed #ebebeb;
}

.paper-card-body {
  padding: 20px;
  border-bottom: 1px dashed #ebebeb;
}

.paper-card-item {
  display: inline-block;
}

.topic-button {
  width: 50px;
  height: 35px;
  display: inline-block;
  line-height: 35px;
  margin: 5px;
  border-radius: 6px;
  color: #454548;
  padding: 0;
}

.topic-button.current {
  background-color: #2aacb2;
  color: #ffffff;
  border-color: #2aacb2;
}

.paper-test {
  padding: 20px;
}

.test-button {
  width: 100%;
}

.clear-error {
  position: absolute;
  top: 10px;
  right: 0;
}

.topic-paper {
  margin-top: 30px;
  padding: 0 20px;
  text-align: right;
  color: #666666;
  font-size: 13px;
}

.topic-html img {
  max-width: 100%;
}
</style>
